import SidebarShell from "@/components/SidebarShell/SidebarShell.vue";
import SidebarContext from "@/components/SidebarContext/SidebarContext.vue";
import SidebarUserFooter from "@/components/SidebarUserFooter/SidebarUserFooter.vue";
import brand_details from "@/data/brand_details";

// IMPORT UTILITIES
import { get_user_profile } from "@/router";
import sidebar_collapsed_inject from "@/components/sidebar_collapsed_inject";

//Getting Company details
const details = brand_details();

export default {
  name: "PropertySidebar",

  components: {
    SidebarShell,
    SidebarContext,
    SidebarUserFooter
  },

  inject: sidebar_collapsed_inject,

  props: {
    active_property: {
      type: Object,
      required: true
    },
    properties: {
      type: Array,
      required: true
    }
  },

  data() {
    return ({
      // MENU STATE
      active_menu_item: "operations_overview",
      dropdownOpen: false,

      //Sub Entity Details
      entity_name: details.sub_entity_name,
      entity_subtitle: details.sub_entity_subtitle,


      // FOOTER
      full_name: "Guest User",
      initials: "GU",

      // BRAND LOGO
      bolide_short_logo: getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-logo")
        .replace(/['"]+/g, "")
    });
  },

  computed: {
    propertiesFormatted() {
      return (this.properties || []).map(item => ({
        id: item.id,
        label: item.title
      }));
    },

    menuItems() {
      return [
        { 
          key: "operations_overview", 
          label: "Real-Time Operations", 
          icon: "bi bi-pie-chart-fill" 
        },

        // --- UTILITIES (Now using Bolide Logo instead of an icon) ---
        { 
          key: "utilities", 
          label: "Utilities", 
          icon: "custom",
          logo: "https://empirewebvideos.s3.us-east-1.amazonaws.com/Probabase_bolide/short_bolide_logo.png"
        },

        // --- ENERGY ---
        { 
          key: "energy", 
          label: "Energy", 
          icon: "bi bi-lightning-charge-fill" 
        },

        // --- SAVINGS INSIGHTS ---
        { 
          key: "savings_insights", 
          label: "Savings Insights", 
          icon: "bi bi-cash-coin" 
        },

        // --- SECURITY & CONNECTIVITY SPLIT ---
        { 
          key: "security", 
          label: "Security", 
          icon: "bi bi-shield-lock-fill" 
        },
        { 
          key: "connectivity", 
          label: "Connectivity", 
          icon: "bi bi-wifi" 
        },

        // --- INSIGHTS, RESOURCES, PARKING ---
        { 
          key: "insights_analytics", 
          label: "Insights & Analytics", 
          icon: "bi bi-graph-up-arrow" 
        },
        { 
          key: "resources", 
          label: "Resources", 
          icon: "bi bi-folder-fill" 
        },
        { 
          key: "parking_access", 
          label: "Parking & Access", 
          icon: "bi bi-car-front-fill" 
        }
      ];
    }
  },

  mounted() {
    this.load_user_name();
    // Auto-select operations_overview when PropertySidebar mounts
    this.selectPropertyMenuItem('operations_overview');
  },

  watch: {
    active_property(newProperty) {
      // Auto-select operations_overview when active property changes
      if (newProperty) {
        this.selectPropertyMenuItem('operations_overview');
      }
    }
  },

  methods: {
    /** FOOTER NAME INITIALS */
    load_user_name() {
      const user = get_user_profile();
      let name = "Guest User";

      if (user && (user.first_name || user.last_name)) {
        name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      } else {
        const first = sessionStorage.getItem("first_name") || "";
        const last = sessionStorage.getItem("last_name") || "";
        name = `${first} ${last}`.trim() || "Guest User";
      }

      if (name === "Guest User" && user?.email) {
        name = user.email.split("@")[0];
      }

      const parts = name.split(" ");
      const initials = ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "GU";

      this.full_name = name;
      this.initials = initials;
    },

    /** DROPDOWN LOGIC */
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    switchProperty(item) {
      this.dropdownOpen = false;

      this.$emit("switch-property", item.id);

      // reset to the first menu item
      this.active_menu_item = "operations_overview";
    },

    backToGlobal() {
      this.dropdownOpen = false;
      this.$emit("go-back");
    },

    /** MENU SELECTION LOGIC */
    selectPropertyMenuItem(menuItem) {
      this.active_menu_item = menuItem;

      this.$emit("property-menu-selected", {
        menuItem,
        propertyId: this.active_property.id,
        propertyName: this.active_property.title
      });
    }
  }
};
